export default __webpack_public_path__ + "fd447f7fff415ae3091f9b23a49b4927.png";